module.exports = __webpack_public_path__ + "img/bind_wechat_logo.b8643769.png";